<template>
  <div class="page">
    <!-- 头部 -->
    <div class="page-header shadow">
      <div class="header-inner">
        <div class="label">统筹单查询：</div>
        <div class="content">
          <el-input placeholder="请输入统筹单流水号/车牌号查询" v-model="keyword">
            <template slot="append"><i class="el-icon-search" @click="handleSearh"></i></template>
          </el-input>
        </div>
      </div>
    </div>
    <!-- 基本信息 -->
    <div class="base-info shadow">
      <el-form :model="formData.bill_data" inline :rules="rules" ref="bill_data" label-width="90px"
        class="demo-ruleForm">
        <el-form-item class="from-item--30" label="统筹起期" prop="beginTime">
          <el-date-picker v-model="formData.bill_data.beginTime" type="datetime" placeholder="选择日期时间" :editable="false"
            @change="(val) => formChange(val, 'beginTime')">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="统筹止期" prop="endTime">
          <el-date-picker v-model="formData.bill_data.endTime" type="datetime" placeholder="选择日期时间" :editable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="统筹天数" prop="days">
          {{
            $tools.getDaysBetween(
              formData.bill_data.beginTime,
              formData.bill_data.endTime
            )
          }}
        </el-form-item>
        <el-form-item class="from-item--30" label="出单公司" prop="orgNo">
          <el-cascader filterable v-model="formData.bill_data.orgNo" :options="$store.state.app.orgList" :props="{
            children: 'children',
            label: 'orgName',
            value: 'id',
            checkStrictly: true,
            emitPath: false,
          }"></el-cascader>
        </el-form-item>
        <el-form-item class="from-item--30" label="业务员" prop="saleNo">
          <el-select v-model="formData.bill_data.saleNo" placeholder="请选择业务员" filterable>
            <el-option v-for="item in $store.state.app.salesmanList" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="交费方式" prop="payType">
          <el-select v-model="formData.bill_data.payType" placeholder="请选择交费方式">
            <!-- <el-option label="净费" :value="0"></el-option> -->
            <el-option label="全费" value="全费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="经办人" prop="HandlerNo">
          <el-select v-model="formData.bill_data.HandlerNo" placeholder="请选择经办人" filterable>
            <el-option v-for="item in $store.state.app.userList" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--100" label="备注" prop="remark">
          <el-input type="textarea" :rows="3" v-model="formData.bill_data.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="from-item--30" label="代报金额" prop="compulsory">
          <el-input v-model="formData.bill_data.compulsory" placeholder="代报金额" />
        </el-form-item>
        <el-form-item class="from-item--30" label="车船税" prop="vessels">
          <el-input v-model="formData.bill_data.vessels" placeholder="车船税" />
        </el-form-item>
      </el-form>
    </div>
    <!-- 车辆信息 -->
    <el-tabs class="card-info shadow" type="border-card">
      <el-tab-pane label="车辆信息">
        <el-form :model="formData.car_data" inline :rules="rules" ref="car_data" label-width="100px"
          class="demo-ruleForm">
          <el-form-item class="from-item--30 has-btn" label="车牌号码" prop="carNo">
            <el-input v-model="formData.car_data.carNo" placeholder="车牌号码" />
            <!-- <el-button
              size="small"
              style="margin-left: 15px"
              type="primary"
              @click="handleSelectCar"
              >选择车辆</el-button
            > -->
            <el-button size="small" style="margin-left: 15px" type="primary" @click="handleAddCar">车辆识别</el-button>
          </el-form-item>
          <el-form-item class="from-item--30" label="发动机号" prop="engineNo">
            <el-input v-model="formData.car_data.engineNo" placeholder="发动机号" />
          </el-form-item>
          <el-form-item class="from-item--30" label="车架号" prop="vin">
            <el-input v-model="formData.car_data.vin" placeholder="车架号" />
          </el-form-item>
          <el-form-item class="from-item--32" label="初登日期" prop="beginDate">
            <el-date-picker v-model="formData.car_data.beginDate" type="date" value-format="yyyy-MM-dd"
              placeholder="选择初登日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="from-item--30" label="能源类型" prop="energyType">
            <el-select v-model="formData.car_data.energyType" filterable>
              <el-option label="燃油" value="燃油"></el-option>
              <el-option label="天然气" value="天然气"></el-option>
              <el-option label="电动" value="电动"></el-option>
              <el-option label="混合动力" value="混合动力"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="使用性质" prop="nature">
            <el-select v-model="formData.car_data.nature" placeholder="请选择使用性质" filterable @change="natureChange">
              <el-option v-for="item in nature" :key="item.id" :label="item.title" :value="item.title"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="车辆种类" prop="carVehicles">
            <el-select v-model="formData.car_data.carVehicles" placeholder="请选择车辆种类" filterable>
              <el-option v-for="item in carVehicles" :key="item.id" :label="item.title" :value="item.title"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="营运性质" prop="usetype">
            <!-- <el-input
              v-model="formData.car_data.usetype"
              placeholder="营运性质"
            /> -->
            <el-select style="width: 100%" v-model="formData.car_data.usetype" placeholder="营运性质">
              <!-- <el-option label="-" value="-"></el-option>
			  <el-option label="营运" value="营运"></el-option>
			  <el-option label="非营运" value="非营运"></el-option>
			  <el-option label="预约出租客运" value="预约出租客运"></el-option> -->
              <el-option v-for="(item, index) in $store.state.app.useType" :key="index" :label="item.lable"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="品牌型号" prop="brandType">
            <el-input v-model="formData.car_data.brandType" placeholder="品牌型号" />
          </el-form-item>
          <!-- <el-form-item class="from-item--30" label="车型" prop="carType">
            <el-input
              v-model="formData.car_data.carType"
              placeholder="车型"
              disabled
            />
          </el-form-item> -->
          <el-form-item class="from-item--30" label="核定载客" prop="passengerCount">
            <el-input v-model="formData.car_data.passengerCount" placeholder="核定载客" />
          </el-form-item>
          <el-form-item class="from-item--30" label="核定载质量" prop="loadWeight">
            <el-input v-model="formData.car_data.loadWeight" placeholder="核定载质量" />
          </el-form-item>
          <el-form-item class="from-item--30" label="新车价" prop="newPrice">
            <el-input v-model="formData.car_data.newPrice" placeholder="新车价" />
          </el-form-item>
          <el-form-item class="from-item--30" label="使用年数" prop="userYears">
            <el-input v-model="formData.car_data.userYears" placeholder="使用年数" />
          </el-form-item>
          <el-form-item class="from-item--30" label="车型" prop="carType">
            <el-select v-model="formData.car_data.carType" placeholder="请选择车型" filterable>
              <el-option v-for="item in $store.state.app.carType" :key="item.label" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            class="from-item--30"
            label="历年状态"
            prop="accidentType"
          >
            <el-input
              v-model="formData.car_data.accidentType"
              placeholder="历年状态"
            />
          </el-form-item> -->
          <el-form-item class="from-item--30" label="实际参考价" prop="nowPrice">
            <el-input v-model="formData.car_data.nowPrice" placeholder="实际参考价"
              @change="(val) => formChange(val, 'nowPrice')" />
          </el-form-item>
          <el-form-item class="from-item--30" label="行驶区域" prop="goArea">
            <el-input v-model="formData.car_data.goArea" placeholder="行驶区域" />
          </el-form-item>
          <el-form-item class="from-item--30" label="验车提示" prop="checkInfo">
            <el-select v-model="formData.car_data.notice" placeholder="请选择验车提示" filterable>
              <el-option v-for="item in $store.state.app.checkInfo" :key="item.label" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="参统年数" prop="insYears">
            <el-input v-model="formData.bill_data.insYears" placeholder="参统年数" />
          </el-form-item>

          <el-form-item class="from-item--30" label="补偿次数" prop="accidentCount">
            <el-input v-model="formData.bill_data.accidentCount" placeholder="参统期补偿次数" />
          </el-form-item>

          <el-form-item class="from-item--30" label="原始统筹" prop="originalBill">
            <el-input v-model="formData.bill_data.originalBill" placeholder="原始统筹" />
          </el-form-item>
          <el-form-item class="from-item--30" label="服务条款" prop="term">
            <el-select v-model="formData.bill_data.term" filterable>
              <el-option v-for="item in term" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="from-item--30" label="原始折扣" prop="originalRebate">
            <el-input v-model="formData.bill_data.originalRebate" placeholder="原始折扣" />
          </el-form-item>

          <el-form-item class="from-item--30" label="车辆大类" prop="carBigType">
            <el-select v-model="formData.car_data.carBigType" placeholder="请选择车辆大类" filterable>
              <el-option v-for="item in $store.state.app.carBigType" :key="item.label" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item class="from-item--30" label="区域码" prop="areaNo">
            <el-input v-model="formData.bill_data.areaNo" placeholder="区域码" />
          </el-form-item> -->
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="关系人信息">
        <FoldedPanel v-for="(item, index) in collapseList" :key="item.title" :name="item.key">
          <template #title>
            <div class="panel-header">
              <span class="panel-header-text">
                <i class="icon el-icon-menu"></i>{{ item.title }}
                <el-checkbox v-if="typeof item.checkProp !== 'undefined'" v-model="item.checkProp"
                  @change="(val) => formChange(val, 'same', index)">同被统筹人</el-checkbox>
              </span>
              <el-button type="text" size="mini" @click="handleSelectPerson(index)"><i class="el-icon-user-solid"></i>
                选择{{
                  item.title
                }}</el-button>
            </div>
          </template>
          <el-form class="panel-form" :model="formData.person_data[index]" inline :rules="rules" ref="ruleForm"
            label-width="100px">
            <el-form-item class="from-item--30" label="类型" prop="personType">
              <el-radio-group v-model="formData.person_data[index].isgroup">
                <el-radio :label="0">个人</el-radio>
                <el-radio :label="1">团队</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="from-item--30" label="名称" prop="personName">
              <el-input v-model="formData.person_data[index].personName" placeholder="名称" />
            </el-form-item>
            <el-form-item class="from-item--30" label="证件号" prop="certNo">
              <el-input v-model="formData.person_data[index].certNo" placeholder="证件号" />
            </el-form-item>
            <el-form-item class="from-item--30" label="电话" prop="tel">
              <el-input v-model="formData.person_data[index].tel" placeholder="电话" />
            </el-form-item>
            <el-form-item class="from-item--30" label="地址" prop="addr">
              <el-input v-model="formData.person_data[index].addr" placeholder="地址" />
            </el-form-item>
            <el-form-item class="from-item--30" label="邮箱" prop="email">
              <el-input v-model="formData.person_data[index].email" placeholder="邮箱" />
            </el-form-item>
          </el-form>
        </FoldedPanel>
      </el-tab-pane>
      <el-tab-pane label="统筹明细">
        <FoldedPanel>
          <template #title>
            <span class="panel-header-text"><i class="icon el-icon-menu">主统筹类型</i></span>
          </template>
          <el-table :data="majorData" style="width: 100%">
            <el-table-column prop="isCheck" label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isCheck"
                  @change="(val) => detailTtemChange(scope.row, 'isCheck')"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="200" label="项目">
              <template slot-scope="scope">
                <div v-if="scope.row.type_id === 4 || scope.row.type_id === 8">
                  <span v-if="!scope.row.isCheck">{{ scope.row.name }}{{ scope.row.special_fee }}元/座
                    <span>
                      共{{
                        formData.car_data.passengerCount - 1 > 0
                          ? formData.car_data.passengerCount - 1
                          : 0
                      }}座</span></span>

                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ scope.row.name }}
                    <el-select v-model="scope.row.special_fee" filterable placeholder="万元" @change="
                      (val) => detailTtemChange(scope.row, 'special_fee')
                    ">
                      <el-option v-for="item in $emun.seatOption" :key="item.label" :value="item.value"
                        :label="item.label"></el-option>
                    </el-select>
                    <span>共{{
                      formData.car_data.passengerCount - 1 > 0
                        ? formData.car_data.passengerCount - 1
                        : 0
                    }}座</span>
                  </div>
                </div>
                <div v-else-if="scope.row.type_id === 1">
                  <span v-if="!scope.row.isCheck">{{
                    `${scope.row.name} 绝对免赔额 ${scope.row.special_fee}`
                  }}</span>
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ `${scope.row.name} 绝对免赔额` }}
                    <el-input v-if="scope.row.type_id === 1" v-model="scope.row.special_fee" placeholder="元" @change="
                      (val) => detailTtemChange(scope.row, 'special_fee')
                    "></el-input>
                  </div>
                </div>
                <div v-else>
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tcfee" label="统筹额(元)">
              <template slot-scope="scope">
                <div v-if="scope.row.type_id === 4 || scope.row.type_id === 8">
                  {{
                    (
                      scope.row.special_fee *
                      (formData.car_data.passengerCount - 1 > 0
                        ? formData.car_data.passengerCount - 1
                        : 0)
                    ).toFixed(2)
                  }}元
                </div>
                <div v-else>
                  <span v-if="!scope.row.isCheck">{{ scope.row.type_id === 10 ? '' : (scope.row.tcfee *
                    1).toFixed(2)+'元' }}</span>
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    <div v-if="scope.row.type_id === 2 || scope.row.type_id === 6">
                      <el-autocomplete class="inline-input" v-model="scope.row.tcfee" :fetch-suggestions="querySearch"
                        placeholder="请输入内容" @select="handleSelect">
                        <template slot-scope="{ item }">
                          <div>{{ item.label }}</div>
                        </template>
                      </el-autocomplete>
                    </div>
                    <div v-else-if="scope.row.type_id === 3">
                      <el-autocomplete class="inline-input" v-model="scope.row.tcfee"
                        :fetch-suggestions="querySearchDriver" placeholder="请输入内容" @select="handleSelect">
                        <template slot-scope="{ item }">
                          <div>{{ item.label }}</div>
                        </template>
                      </el-autocomplete>
                    </div>
                    <div v-else-if="scope.row.type_id === 10"></div>
                    <el-input v-else v-model="scope.row.tcfee" placeholder="元"
                      @change="(val) => detailTtemChange(scope.row, 'tcfee')"></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bztcfee" label="标准统筹费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ (scope.row.bztcfee * 1).toFixed(2) }}元</span>
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input v-model="scope.row.bztcfee" placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'bztcfee')"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="yjtcfee" label="应交统筹费(元)">
              <template slot-scope="scope">
                {{
                  (formData.bill_data.cusRebate * scope.row.bztcfee).toFixed(2)
                }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <div class="flex mb15">
          <div></div>
          <el-button type="primary" @click="handleStandard">获取标费</el-button>
        </div>
        <FoldedPanel>
          <template #title>
            <span class="panel-header-text"><i class="icon el-icon-menu">附加统筹类型</i></span>
          </template>
          <el-table :data="additionData" style="width: 100%">
            <el-table-column prop="isCheck" label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isCheck"
                  @change="(val) => detailTtemChange(scope.row, 'isCheck')"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="200" label="项目">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ scope.row.name }}</span>
                <div class="input-wrap" v-if="scope.row.isCheck">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tcfee" label="统筹额(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ (scope.row.tcfee * 1).toFixed(2) }}元</span>
                <!-- <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.tcfee"
                    placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'tcfee')"
                  ></el-input>
                </div> -->
                <el-autocomplete
                  v-if="scope.row.isCheck && (scope.row.name.includes('三者') || scope.row.name.includes('司乘'))"
                  class="inline-input" v-model="scope.row.tcfee" :fetch-suggestions="querySearchAdditional"
                  placeholder="请输入内容" @select="detailTtemChange(scope.row, 'tcfee')">
                  <template slot-scope="{ item }">
                    <div>{{ item.label }}</div>
                  </template>
                </el-autocomplete>
                <div class="input-wrap"
                  v-if="scope.row.isCheck && scope.row.name.includes('三者') == false && scope.row.name.includes('司乘') == false">
                  <el-input v-model="scope.row.tcfee" placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'tcfee')"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bztcfee" label="标准统筹费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ (scope.row.bztcfee * 1).toFixed(2) }}元</span>
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input v-model="scope.row.bztcfee" placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'bztcfee')"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="yjtcfee" label="应交统筹费(元)">
              <template slot-scope="scope">
                {{ (scope.row.yjtcfee * 1).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <div class="panel-detail-footer">
          <div class="panel-detail-footer-left">
            <div class="label">整单折扣：</div>
            <el-input v-model="formData.bill_data.cusRebate" placeholder="折扣"
              @change="(val) => detailTtemChange({}, 'cusRebate')"></el-input>
          </div>
          <div class="panel-detail-footer-right">
            <span class="mr15">标准统筹费合计：{{ standardTotal }}元</span>
            <span>应交统筹费合计：{{ practicalTotal }}元</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="附件">
        <el-card size="small" class="box-card" v-for="(item, index) in encList" :key="index">
          <template slot="header">
            <div class="enc">
              <div class="encTitle">
                <i class="el-icon-info"></i>
                <span>{{ item.title }}</span>
              </div>
              <div class="encNum">
                <span>{{ item.fileList.length }}/{{ item.max }}</span>
                张文件
              </div>
            </div>
          </template>
          <div class="img-list">
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="item.fileList" :limit="item.max"
              :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file, item)"
              :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList, item)
                ">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="preVisible">
              <img width="100%" :src="preImageUrl" alt="" />
            </el-dialog>
            <div v-if="item.thumbnail" class="eg-img">
              <span>示例：</span>
              <el-image style="width: 100px; height: 100px" :src="item.thumbnail" :preview-src-list="[item.thumbnail]">
              </el-image>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="特别约定">
        <el-button class="select-btn" type="primary" @click="handleSelectTemp">选择模版</el-button>
        <el-input v-model="formData.bill_data.specialRemark" type="textarea" :rows="4" placeholder="请输入特别约定">
        </el-input>
      </el-tab-pane>
    </el-tabs>
    <div class="confirm">
      <el-button type="primary" @click="saveInfoTempor">暂存</el-button>
      <el-button type="primary" @click="saveInfo">保存统筹单信息</el-button>
      <el-button type="info" @click="resetInfo">重置</el-button>
    </div>
    <el-drawer :title="drawerCfg.title" :visible.sync="drawerCfg.visiable" direction="rtl" :close="drawerClosed"
      :size="drawerCfg.size" destroy-on-close>
      <!-- 选择车辆相关 -->
      <div class="drawer-content" v-if="drawerFlag === 'selectCar'">
        <BaseSearch v-model="carSearchData" :formOptions="carSearchFormOption" @handleSearch="handleTableSearch"
          labelWidth="70px">
        </BaseSearch>
        <el-button type="primary" ref="addCarRef" @click="handleAddCar"> + 新增</el-button>
        <BaseTable ref="baseTable" url="/admin/car/index" :tableData.sync="carTableData" :columns="carColumns"
          :searchParams="carSearchData">
          <template #custom="{ scope }">
            {{ scope.row.title }}
          </template>
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="handleEditCar(row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handleSelectOneCar(row)">选择车辆</el-button>
          </template>
        </BaseTable>
      </div>

      <!-- 选择关系人相关 -->
      <div class="drawer-content" v-if="drawerFlag === 'selectPerson'">
        <BaseSearch v-model="personSearchData" :formOptions="personSearchFormOption" @handleSearch="handleTableSearch"
          labelWidth="70px">
        </BaseSearch>
        <el-button type="primary" @click="handleAddPerson"> + 新增</el-button>
        <BaseTable ref="baseTable" url="/admin/person/index" :tableData.sync="personTableData" :columns="personColumns"
          :searchParams="personSearchData">
          <template #custom="{ scope }">
            {{ scope.row.title }}
          </template>
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="handleEditPerson(row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handleSelectOnePerson(row)">选择关系人</el-button>
          </template>
        </BaseTable>
      </div>

      <!-- 特别约定相关 -->
      <div class="drawer-content" v-if="drawerFlag === 'selectTemp'">
        <BaseTable ref="baseTable" url="/admin/special/index" :tableData.sync="tempTableData" :columns="tempColumns"
          :hasSelection="true" :hasIndex="false" @handleSelectionChange="handleSelectionChange"></BaseTable>
        <el-button type="primary" @click="handleDialogComfirm">保存</el-button>
      </div>
    </el-drawer>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" @close="dialogClosed">
      <BaseForm v-if="drawerFlag === 'selectCar'" ref="baseForm" v-model="carFormData" :rules="carRules"
        :formOptions="carFormOption" labelWidth="120px" v-loading="loading" @paste.native="(val) => inputPaste($event)">
        <template #uploadBtn>
          <el-upload class="uploader" action="#" :show-file-list="false" :on-change="handleChangeFileCar"
            :before-upload="beforeUpload" :auto-upload="false">
            <el-button type="primary">上传行驶证照片</el-button>
          </el-upload>
        </template>
      </BaseForm>
      <BaseForm v-if="drawerFlag === 'selectPerson'" v-loading="loading" ref="baseForm" v-model="personFormData"
        :rules="personRules" :formOptions="personFormOption" labelWidth="120px">
        <template #uploadBtn>
          <el-upload v-if="personFormData.type === 0" class="uploader" action="#" :show-file-list="false"
            :on-change="handleChangeFilePerson" :before-upload="beforeUpload" :auto-upload="false">
            <el-button type="primary">上传身份证照片</el-button>
          </el-upload>
          <el-upload v-if="personFormData.type === 1" class="uploader" action="#" :show-file-list="false"
            :on-change="handleChangeLicenseFile" :before-upload="beforeUpload" :auto-upload="false">
            <el-button type="primary">上传营业执照</el-button>
          </el-upload>
        </template>
      </BaseForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDialogComfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 精友查询选择车辆新车价 -->
    <el-dialog :visible.sync="jySelectNewPrice" width="35%" @close="jySelectNewPrice = false">

      <el-table :data="carSelectTableData" :stripe="true" :border="true">
        <el-table-column prop="newPrice" label="新车价(元)" align="center"></el-table-column>
        <el-table-column prop="passengerCount" label="核定载客(人)" align="center"></el-table-column>
        <el-table-column prop="loadWeight" label="核定载质量(千克)" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <el-button type="text" @click="hanldeSelectCar(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { rules } from "./rules";
import { carFormOption } from "@/views/basics/car/formOptions";
import { columns as carColumns } from "@/views/basics/car/columns";
import { searchFormOption as carSearchFormOption } from "@/views/basics/car/formOptions";
import { rules as carRules } from "@/views/basics/car/rules";

import { personFormOption } from "@/views/basics/privy/formOptions";
import { columns as personColumns } from "@/views/basics/privy/columns";
import { searchFormOption as personSearchFormOption } from "@/views/basics/privy/formOptions";
import { rules as personRules } from "@/views/basics/privy/rules";

import { columns as tempColumns } from "@/views/system/agreement/columns";

export default {
  name: "Recording",
  comments: {},
  data() {
    return {
      syncDataTcfee: '',
      keyword: "",
      standardTotal: 0, // 标准合计
      practicalTotal: 0, // 应交合计
      selections: [],
      loading: false,
      preVisible: false,
      jySelectNewPrice: false,
      preImageUrl: "",
      cusRebate: 1,
      formData: {
        //主要信息
        bill_data: {
          cusRebate: 1,
          specialRemark: "",
          orgNo: this.$store.state.user.org_id,
          payType: "全费",
          term: 0,
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
        },
        //人员关系信息
        person_data: [
          {
            personType: 0,
            isgroup: 0,
          },
          {
            personType: 1,
            isgroup: 0,
          },
          {
            personType: 2,
            isgroup: 0,
          },
        ],
        //附件信息
        enc_data: [],
        //统筹详细信息
        detail_data: {},
      },
      rules: rules(this),
      // 附件相关
      identityPhoto: [],
      drivingPhoto: [],
      businessPhoto: [],
      validatePhoto: [],
      standardPhoto: [],
      otherPhoto: [],
      paymentPhoto: [],
      dangerNum: [],
      activeCollapseNames: [1],
      planCollapseNames: [1],
      // 抽屉相关
      drawerCfg: {
        title: "",
        visiable: false,
        size: "40%",
      },
      drawerFlag: "",
      // 弹框相关
      dialogVisible: false,
      dialogTitle: "新增车辆信息",
      // 选择车辆相关
      carFormData: {},
      carSearchData: {},
      carTableData: [],
      carSelectTableData: [],
      carSubmitFlag: "add",
      // 选择人物相关
      personFormData: {},
      personSearchData: {},
      personTableData: [],
      personSubmitFlag: "add",
      // 选择模版相关
      tempTableData: [],
      collapseList: [
        {
          title: "被统筹人",
          key: 0,
        },
        {
          title: "参统人",
          key: 1,
          checkProp: false,
        },
        {
          title: "车主",
          key: 2,
          checkProp: false,
        },
      ],
      // 主统筹列表
      majorData: [],
      // 附加统筹列表
      additionData: [],
      // 使用性质
      nature: [],
      // 车辆种类
      carVehicles: [],
      // 服务条款
      term: [],
      // 是否为续统
      whetherxt: 0,
      // 选中的附加统筹id（编辑回显使用）
      additionId: [],
    };
  },
  computed: {
    /**
     * 车辆相关
     */
    carFormOption,
    carColumns, // 车辆列信息
    carSearchFormOption, // 车辆搜索头部
    carRules,
    /**
     * 车辆相关结束
     */
    /**
     * 选择人物相关
     */
    personFormOption,
    personColumns, // 车辆列信息
    personSearchFormOption, // 车辆搜索头部
    personRules,
    /**
     * 选择人物结束
     */
    /**
     * 特别约定相关
     */
    tempColumns() {
      const col = tempColumns();
      col.splice(col.length - 1, 1);
      return col;
    },
    /**
     * 特别约定相关结束
     */
    // 附件相关
    encList() {
      //附件
      return [
        {
          title: "身份证",
          imageType: 1,
          max: 5,
          fileList: this.identityPhoto,
          prop: "identityPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/311586697b54e14da8be5966ca7cea82.jpg",
        },
        {
          title: "行驶证",
          imageType: 2,
          max: 5,
          fileList: this.drivingPhoto,
          prop: "drivingPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/93a43fbefc8c2f8ed032e7c02de34263.jpeg",
        },
        {
          title: "出险次数截图",
          imageType: 7,
          max: 5,
          fileList: this.dangerNum,
          prop: "dangerNum",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/7bacafadbbd691bb082253047c549380.jpeg",
        },
        {
          title: "支付凭证截图",
          imageType: 8,
          max: 5,
          fileList: this.paymentPhoto,
          prop: "paymentPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/44dddf01e40f0c98a46a6a7256cb84ef.jpeg",
        },
        {
          title: "营业执照",
          imageType: 3,
          max: 5,
          fileList: this.businessPhoto,
          prop: "businessPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/dceb23dcba4d1074288ec572e5c8c2f7.jpg",
        },
        {
          title: "验车照片",
          imageType: 4,
          max: 5,
          fileList: this.validatePhoto,
          prop: "validatePhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/06d2b326be98531b3a74a1fd58a426e4.jpg",
        },
        {
          title: "标准费用参考图",
          imageType: 5,
          max: 5,
          fileList: this.standardPhoto,
          prop: "standardPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/3c42b2fe8b113473cbc79f4997d939ba.png",
        },
        {
          title: "其他",
          imageType: 6,
          max: 8,
          fileList: this.otherPhoto,
          prop: "otherPhoto",
        },
      ];
    },
  },
  watch: {
    $route: {
      async handler(val) {
        const { insBillId, whetherxt } = val.query;
        if (whetherxt) {
          this.whetherxt = whetherxt;
        }
        if (insBillId) {
          this.insBillId = insBillId;
          await this.getOwnerDetailList();
          await this.handleSearh();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if (!this.formData.bill_data.beginTime) {
      const month = this.$moment().add(1, "days").format("YYYY-MM-DD");
      // 获取当前时间
      this.formData.bill_data = {
        ...this.formData.bill_data,
        beginTime: this.$moment(`${month} 00:00:00`).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
    }
    if (!this.formData.bill_data.endTime) {
      const month = this.$moment().add("year", 1).format("YYYY-MM-DD");
      // 获取当前时间
      this.formData.bill_data = {
        ...this.formData.bill_data,
        endTime: this.$moment(`${month} 23:59:59`).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
    }

    this.getOwnerDetailList();
    // this.getOwnerDetailList(2)
    // this.formChange(this.$moment('').format('YYYY-MM-MM HH:mm:ss'), 'beginTime')
    this.$store.dispatch("app/getCarType");
    this.$store.dispatch("app/getCarBigType");
    // 获取使用性质
    this.getNature();
    // 获取特别约定
    this.special();
    // 获取服务条款
    this.getTerm();
    // 营业性质
    this.$store.dispatch("app/getUseType");
    // 验车提示
    this.$store.dispatch("app/getCheckInfo");

    // 从客户列表进来的
    const { isCustomer, personName, certNo, tel, addr } = this.$route.query;
    if (isCustomer == 1) {
      this.carFormData = { ...this.$route.query };
      this.formData.person_data[0].personName = personName;
      this.formData.person_data[0].certNo = certNo;
      this.formData.person_data[0].tel = tel;
      this.formData.person_data[0].addr = addr;
      this.handleAddCar();
    }
  },
  methods: {
    getToken,
    async getNature() {
      const arr = [];
      this.$api.post("/admin/rate/getNature", {}).then((res) => {
        this.nature = res.data;
      });
    },
    // 获取特别约定
    async special() {
      this.$api.post("/admin/special/index", {}).then((res) => {
        if (res.data.data) {
          this.formData.bill_data.specialRemark = res.data.data[0].tyContent;
        }
      });
    },
    // 获取服务条款
    async getTerm() {
      this.$api.post("/admin/carHeTong/getTerm", {}).then((res) => {
        if (res.data.data) {
          if (this.formData.bill_data.term == 0) {
            this.formData.bill_data.term = res.data.data[0].id
          }
          this.term = res.data.data;
        }
      });
    },
    // 下拉框更新
    async natureChange(val) {
      this.carVehicles = [];
      delete this.formData.car_data.carVehicles;
      this.$api.post("/admin/rate/getNature", { 'title': val }).then((res) => {
        this.carVehicles = res.data;
      });
    },
    // 粘贴信息，自动拆分
    inputPaste(even) {
      if (even.target.className != 'el-textarea__inner') {
        return;
      }
      var pastedText = undefined
      if (event.clipboardData && event.clipboardData.getData) {
        pastedText = event.clipboardData.getData('Text');
      } else {
        pastedText = event.originalEvent.clipboardData.getData('Text');
      }
      this.$api.post("/admin/rate/strMate", { 'pastedText': pastedText }).then((res) => {
        res.data.textIdentify = pastedText;
        this.carFormData = { ...res.data };
      });

    },
    // 图片上传之前
    beforeUpload(file) {

    },
    // 获取统主筹明细列表
    async getOwnerDetailList() {
      const res = await this.$api.post("/admin/other/get_detail_type");

      let check = false;
      let tcff = 0;
      let special_fee = 0;
      this.majorData = res.data.map((item) => {
        check = false;
        // if(!this.insBillId && item.id >= 1 && item.id <= 4){
        //  check = true;
        //  if(item.id == 1 || item.id == 2){
        //  tcff = '1000000'; 
        //  }else{
        //   tcff = '10000'; 
        //  }
        //  special_fee = '10000';
        // }
        // if(check == true){
        //  this.getAttchDetaiList(item.id);
        // }
        item = {
          ...item,
          isCheck: check,
          special_fee: special_fee, // 项目列里可输入字段
          tcfee: tcff, // 统筹额
          bztcfee: 0, // 标准统筹费
          yjtcfee: 0, // 应缴金额
          discount: 1, // 折扣
          type_id: item.id,
          type_pid: item.pid,
        };
        return item;
      });

      //console.log(this.majorData, this.additionData, "tongchoulieixng");
    },
    // 根据父级id获取子级附加类型明细数据
    async getAttchDetaiList(type_id) {
      const res = await this.$api.post("/admin/other/get_detail_son_type", {
        type_id,
      });
      let additionArr = [];
      const list = res.data.map((item) => {
        if (this.additionId.includes(item.id)) {
          this.additionId = this.additionId.filter(items => items !== item.id);
          return;
        }
        additionArr.push({
          ...item,
          isCheck: this.additionId.includes(item.id),
          special_fee: 0, // 项目列里可输入字段
          tcfee: item.amount, // 统筹额
          bztcfee: item.amountFee, // 标准统筹费
          yjtcfee: item.amountFee, // 应缴金额
          discount: 1, // 折扣
          type_id: item.id,
          type_pid: item.pid,
        });
        return item;
      });
      this.additionData = [...this.additionData, ...additionArr];
      //console.log(this.additionData);
    },
    // 回显详情
    async handleSearh(selectCarNo) {
      let res = {};
      res = await this.$api.post("/admin/insbill/getTheDetail", {
        keyword: this.keyword || selectCarNo || this.insBillId,
        whetherxt: this.whetherxt
      });
      // 取消选中的复选框
      this.majorData = this.majorData.map((ele) => {
        ele.isCheck = false;
        if (res.data.item) {
          res.data.item.forEach((element) => {
            if (element.type_id === ele.id) {
              ele = {
                ...element,
                isCheck: true,
              };
            }
          });
        } else {
          if (ele.id >= 1 && ele.id <= 4) {
            ele.isCheck = true;
            if (ele.id == 1 || ele.id == 2) {
              ele.tcfee = '1000000';
            } else {
              // 核定载客
              ele.tcfee = '10000';
            }
            ele.special_fee = '10000';
            if (ele.isCheck == true) {
              this.getAttchDetaiList(ele.id);
            }
          }
        }
        if (ele.isCheck == false) {
          ele.tcfee = 0;
          ele.yjtcfee = 0;
          ele.bztcfee = 0;
          ele.special_fee = 0;
        }
        return ele;
      });

      // 安行宝存一个默认值
      this.syncDataTcfee = this.majorData[0].tcfee

      if (res.data.item) {
        res.data.item.forEach((element) => {
          if (element.type_pid > 0) {
            this.additionData.push({ ...element, isCheck: true });
            this.additionId.push(element.type_id);
          } else {
            this.getAttchDetaiList(element.type_id);
          }

        });
      }
      // 没查到信息不进行赋值
      if (res.data.base == undefined) {
        return;
      }

      // if(selectCarNo) {
      //     res = await this.$api.post("/admin/insbill/getTheDetail", {
      //     keyword: selectCarNo,
      //   });
      // } else {
      //     res = await this.$api.post("/admin/insbill/getDetailByBid", {
      //     insBillId: this.keyword || this.insBillId ,
      //   });
      // }

      //console.log(res.data.base);
      // 回显基本信息
      const billData = {
        ...res.data.base,
      };
      //回显车辆信息
      const carData = (res.data.car == undefined) ? this.formData.car_data : res.data.car;

      // 回显关系人信息
      const personData = res.data.person ? [...res.data.person] : [
        {
          personType: 0,
          isgroup: 0,
        },
        {
          personType: 1,
          isgroup: 0,
        },
        {
          personType: 2,
          isgroup: 0,
        },
      ];

      this.identityPhoto = [];
      this.drivingPhoto = [];
      this.businessPhoto = [];
      this.validatePhoto = [];
      this.standardPhoto = [];
      this.otherPhoto = [];
      this.dangerNum = [];
      this.paymentPhoto = [];
      // 回显附件信息
      if (res.data.enc) {
        res.data.enc.forEach((ele) => {
          if (ele.imageType === 1) {
            this.identityPhoto.push(ele);
          }
          if (ele.imageType === 2) {
            this.drivingPhoto.push(ele);
          }
          if (ele.imageType === 3) {
            this.businessPhoto.push(ele);
          }
          if (ele.imageType === 4) {
            this.validatePhoto.push(ele);
          }
          if (ele.imageType === 5) {
            this.standardPhoto.push(ele);
          }
          if (ele.imageType === 6) {
            this.otherPhoto.push(ele);
          }
          if (ele.imageType === 7) {
            this.dangerNum.push(ele);
          }
          if (ele.imageType === 8) {
            this.paymentPhoto.push(ele);
          }
        });
      }

      if (res.data.base) {
        this.standardTotal = res.data.base.contractFee;
        this.practicalTotal = res.data.base.cusFee;
      } else {
        this.standardTotal = 0;
        this.practicalTotal = 0;
      }
      // this.standardTotal = res.data.base.contractFee || 0;
      // this.practicalTotal = res.data.base.cusFee || 0;

      //console.log(this.majorData);
      // 查询车辆种类
      if (res.data.car.nature) {
        this.natureChange(res.data.car.nature);
      }
      this.formData = {
        bill_data: {
          ...billData,
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
          ...carData,
        },
        //人员关系信息
        person_data: [...personData],
        //附件信息
        enc_data: [],
        //统筹详细信息
        detail_data: {},
        // 特别约定
        template_data: {
          templateContent: "",
        },
        // car_data: res.data.car,
        // bill_data: res.data.base,
      };
      // this.formData.bill_data
      this.insBillId = billData.insBillId;
    },

    // 基本信息fromchange
    formChange(val, prop, index) {
      //console.log(val, prop, this.formData.bill_data.endTime);
      switch (prop) {
        case 'beginTime':
          //if(!this.formData.bill_data.endTime) {
          this.formData.bill_data = {
            ...this.formData.bill_data,
            endTime: this.$moment(val).add(1, 'y').subtract(1, 's').format("YYYY-MM-DD HH:mm:ss"),
          }
          //}
          break;
        case "same": // 选择同被统筹人
          if (val) {
            this.formData.person_data = this.formData.person_data.map(
              (item, ind) => {
                if (index === ind) {
                  item = {
                    ...item,
                    ...this.formData.person_data[0],
                    personType: item.personType,
                  };
                }
                return item;
              }
            );
          }
          break;
        case "nowPrice":
          if (this.majorData.length) {
            this.majorData = this.majorData.map((item) => {
              if (item.id === 1) {
                item.tcfee = val;
              }
              return item;
            });
          }

          break;
        default:
          break;
      }
    },
    /**
     * 选择车辆相关
     */
    // 选择车辆
    handleSelectCar() {
      // this.drawerFlag = "selectCar";
      // this.drawerCfg = {
      //   title: "选择车辆信息",
      //   visiable: true,
      //   size: "60%",
      // };
      // 自动触发新增车辆
      //this.handleAddCar();

      //this.handleTableSearch();
    },

    // 表格搜索
    handleTableSearch() {
      this.$nextTick(() => {
        this.$refs.baseTable.searchData();
      });
    },

    // 车辆新增
    handleAddCar() {
      this.drawerFlag = "selectCar";
      this.dialogTitle = "新增车辆信息";
      this.dialogVisible = true;
      this.carSubmitFlag = "add";
    },

    // 点击编辑车辆
    handleEditCar(row) {
      this.dialogTitle = "编辑车辆信息";
      this.carSubmitFlag = "edit";
      this.dialogVisible = true;
      this.carFormData = {
        ...row,
      };
    },
    // 精友返回数据后选择新车价
    hanldeSelectCar(row) {
      this.formData.car_data.loadWeight = row.loadWeight;
      this.formData.car_data.newPrice = row.newPrice;
      this.formData.car_data.nowPrice = row.nowPrice;
      this.formData.car_data.passengerCount = row.passengerCount;
      this.jySelectNewPrice = false;
      this.majorData = this.majorData.map((item) => {
        if (item.type_id === 1) {
          item.tcfee = this.formData.car_data.nowPrice ? this.formData.car_data.nowPrice : 0;
        }
        if (item.type_id == 4) {
          item.tcfee = item.tcfee * (row.passengerCount - 1);
        }
        return item;
      })
    },
    // 车辆信息提交
    handleCarSubmit() {
      //console.log(this.carFormData, "-----------fsfsf");
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let msg = "";
              if (this.carSubmitFlag === "add") {
                msg = "新增车辆";
              } else {
                msg = "编辑车辆";
              }
              //console.log(this.carFormData);
              await this.$api.post("/admin/car/save", this.carFormData, msg).then((res) => {
                this.dialogVisible = false;
                //this.handleTableSearch();

                this.handleSelectOneCar(this.carFormData);
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },

    // 选择了某一辆车辆
    handleSelectOneCar(row) {
      //console.log(row);
      // 查询精友车辆信息
      this.$api.post("/admin/rate/getCarJy", { 'carNo': row.carNo }).then((res) => {
        if (res.data.length < 2) {
          row.loadWeight = res.data[0].loadWeight || '';
          row.newPrice = res.data[0].newPrice || '';
          row.nowPrice = res.data[0].nowPrice || '';
          row.passengerCount = res.data[0].passengerCount || '';
          // this.majorData = this.majorData.map((item) => {
          // 	if (item.type_id === 1){
          // 		item.tcfee = row.nowPrice;
          // 	}
          // if (item.type_id === 4){
          // 	item.tcfee = item.tcfee*(row.passengerCount-1);
          // }
          // 	return item;
          // })

          this.carSelectTableData = res.data;
          this.jySelectNewPrice = true;
        } else {
          this.carSelectTableData = res.data;
          this.jySelectNewPrice = true;
        }
        // 默认选中使用性质
        row.nature = '非营业货车';
        row.energyType = '燃油';

        this.formData.car_data = {
          ...row,
          userYears: this.$moment()
            .diff(this.$moment(row.beginDate), "year", true)
            ?.toFixed(0),
        };
      });

      //console.log(this.formData.car_data)
      this.natureChange('非营业货车');

      this.handleSearh(row.carNo);
      this.drawerCfg.visiable = false;
    },

    async handleChangeFileCar(file) {
      //console.log(file);
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      //console.log(fd);
      const res = await this.$api.upload("/admin/upload/upload_driving", fd);
      this.loading = false;
      if (!res) return;
      if (!res.data.is_license) {
        this.$message.warning("只支持行驶证图片");
        return;
      }
      // beginDate 20200909
      const year = res.data.info?.beginDate.slice(0, 4);
      const month = res.data.info?.beginDate.slice(4, 6);
      const day = res.data.info?.beginDate.slice(6, 8);
      //console.log(`${year}-${month}-${day}`);
      this.carFormData = {
        ...this.carFormData,
        ...res.data.info,
        beginDate: new Date(`${year}-${month}-${day}`),
      };

      //console.log(this.formData, res, "------res");
    },

    /**
     * 车辆相关结束
     */

    /**
     * 关系人信息相关
     */
    // 选择关系人
    handleSelectPerson(index) {
      this.personIndex = index;
      this.drawerFlag = "selectPerson";
      this.drawerCfg = {
        title: "选择关系人",
        visiable: true,
        size: "60%",
      };
      this.handleTableSearch();
    },

    async handleChangeFilePerson(file) {
      //console.log(file);
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      fd.append("side", "front");
      const res = await this.$api.upload("/admin/upload/upload_iden", fd);
      this.loading = false;
      if (!res) return;
      if (!res.data.is_iden) {
        this.$message.warning("只支持身份证照片");
        return;
      }
      if (!res.data.info.status !== "normal") {
        this.$message.warning(
          "检测到您上传的照片有遮挡或者模糊，会导致信息识别不全"
        );
      }
      this.personFormData = {
        ...this.personFormData,
        personName: res.data.info.name,
        addr: res.data.info.addr,
        certNo: res.data.info.iden_num,
      };

      //console.log(this.formData, res, "------res");
    },

    async handleChangeLicenseFile(file) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      fd.append("side", "front");
      const res = await this.$api
        .upload("/admin/upload/business", fd)
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
      if (!res) return;
      if (!res.data.code) {
        this.$message.warning("只支持营业执照照片");
        return;
      }

      this.personFormData = {
        ...this.personFormData,
        personName: res.data.unit_name,
        addr: res.data.address,
        certNo: res.data.code,
      };
    },

    // 人物新增
    handleAddPerson() {
      this.dialogTitle = "新增关系人信息";
      this.dialogVisible = true;
      this.personSubmitFlag = "add";
      this.personFormData = {
        type: 0,
      };
    },

    // 点击编辑人物
    handleEditPerson(row) {
      this.dialogTitle = "编辑关系人信息";
      this.personSubmitFlag = "edit";
      this.dialogVisible = true;
      this.personFormData = {
        ...row,
      };
    },

    // 人物信息提交
    handlePersonSubmit() {
      //console.log(this.personFormData);
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let msg = "";
              if (this.personSubmitFlag === "add") {
                msg = "新增关系人";
              } else {
                msg = "编辑关系人";
              }

              await this.$api.post(
                "/admin/person/save",
                this.personFormData,
                msg
              );
              this.dialogVisible = false;
              this.handleTableSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },

    // 选择了某一个人
    handleSelectOnePerson(row) {
      this.formData.person_data = this.formData.person_data.map(
        (item, index) => {
          if (this.personIndex === index) {
            item = {
              ...item,
              ...row,
            };
          }
          return item;
        }
      );
      this.drawerCfg.visiable = false;
    },
    /**
     * 关系人信息相关结束
     */

    /**
     * 统筹明细相关
     */
    querySearch(k, cb) {
      cb(this.$emun.moneyType);
    },
    querySearchDriver(k, cb) {
      cb(this.$emun.seatOption);
    },
    querySearchAdditional(k, cb) {
      cb(this.$emun.additionalOption);
    },
    handleSelect(row, prop) {
      // if(prop === 'tcfee'){
      // 	this.additionData = this.additionData.map((item) => {
      // 		if(prop === 'tcfee' && item.id == row.id){
      // 			if(row.tcfee == 10000){
      // 				item.bztcfee = 100;
      // 				item.yjtcfee = 100;
      // 			}
      // 			 if(row.tcfee == 20000){
      // 				item.bztcfee = 200;
      // 				item.yjtcfee = 200;
      // 			 }
      // 			 if(row.tcfee == 50000){
      // 				item.bztcfee = 300;
      // 				item.yjtcfee = 300;
      // 			 }
      // 			 if(row.tcfee == 100000){
      // 				item.bztcfee = 600;
      // 				item.yjtcfee = 600;
      // 			 }
      // 		}
      // 	  return item;
      // 	});
      // }
    },
    detailTtemChange(row, prop) {
      // 父级选中，请求子级数据
      if (row.type_pid === 0 && prop === "isCheck" && row.isCheck) {
        // 安行宝项目中，9是‘外部电网故障损失服务’，在这里做处理，为其同步‘车辆损失权益 绝对免赔额’的值
        if (row.type_id == 9) {
          this.majorData.forEach((item) => {
            if (item.type_id == 9) {
              item.tcfee = this.syncDataTcfee
            }
          });
        }

        // 添加附加统筹类型
        this.getAttchDetaiList(row.type_id);
      } else if (row.type_pid === 0 && prop === "isCheck" && !row.isCheck) {
        // 删除附加统筹类型
        this.additionData = this.additionData.filter(
          (item) => item.type_pid !== row.type_id
        );

      }
      this.standardTotal = 0;
      this.practicalTotal = 0;
      this.majorData = this.majorData.map((item) => {
        // 计算总价
        if (item.isCheck) {
          this.standardTotal += item.bztcfee * 1;
          this.practicalTotal +=
            item.bztcfee * 1 * this.formData.bill_data.cusRebate;
          // if (item.type_id === 1 && this.firstSelectDetail){
          // 	item.tcfee = this.formData.car_data.nowPrice?this.formData.car_data.nowPrice:0;
          // 	this.firstSelectDetail = false;
          // }
        }
        if (item.type_id === 4 || item.type_id === 8) {
          item.tcfee =
            item.special_fee *
            (this.formData.car_data.passengerCount - 1 > 0
              ? this.formData.car_data.passengerCount - 1
              : 0);
          // console.log(
          //   item,
          //   this.formData.car_data.passengerCount - 1 > 0
          //     ? this.formData.car_data.passengerCount - 1
          //     : 0
          // );
        }
        item.yjtcfee = this.formData.bill_data.cusRebate * item.bztcfee;
        return item;
      });
      this.additionData = this.additionData.map((item) => {
        if (prop === 'tcfee' && item.id == row.id) {
          if (row.tcfee == 10000) {
            item.bztcfee = 100;
            item.yjtcfee = 100;
          }
          if (row.tcfee == 20000) {
            item.bztcfee = 200;
            item.yjtcfee = 200;
          }
          if (row.tcfee == 50000) {
            item.bztcfee = 300;
            item.yjtcfee = 300;
          }
          if (row.tcfee == 100000) {
            item.bztcfee = 600;
            item.yjtcfee = 600;
          }
        }
        if (item.isCheck) {
          this.standardTotal += item.bztcfee * 1;
          this.practicalTotal +=
            item.bztcfee * 1 * this.formData.bill_data.cusRebate;
        }
        item.yjtcfee = this.formData.bill_data.cusRebate * item.bztcfee;

        return item;
      });

      this.standardTotal = this.standardTotal.toFixed(2);
      this.practicalTotal = this.practicalTotal.toFixed(2);
    },
    // 获取标费
    handleStandard() {
      //this.$message.info("功能正在建设中");
      const energyType = this.formData.car_data.energyType;
      const nature = this.formData.car_data.nature;
      const carVehicles = this.formData.car_data.carVehicles;
      const beginDate = this.formData.car_data.beginDate;

      if (this.majorData[0]['isCheck'] || this.majorData[1]['isCheck'] || this.majorData[2]['isCheck'] || this.majorData[3]['isCheck']) {
        if (nature === undefined) {
          this.$message.warning("请选择使用性质");
          return;
        }
        if (carVehicles === undefined) {
          this.$message.warning("请选择车辆种类");
          return;
        }
        if (this.majorData[0]['isCheck'] && beginDate === undefined) {
          this.$message.warning("请输入车辆初登日期");
          return;
        }
      }
      let tcfee = 0;
      let sz_tcfee = 0;
      let sj_tcfee = 0;
      let ck_tcfee = 0;
      let seat = 0;
      this.majorData.map((item) => {
        if (item.type_id == 1 && item.isCheck) {
          // 车损
          tcfee = item.tcfee;
        }
        if (item.type_id == 2 && item.isCheck) {
          // 三者
          sz_tcfee = item.tcfee;
        }
        if (item.type_id == 3 && item.isCheck) {
          // 司机
          sj_tcfee = item.tcfee;
        }
        if (item.type_id == 4 && item.isCheck) {
          // 乘客
          ck_tcfee = item.tcfee;
          seat = this.formData.car_data.passengerCount; // 座位数
        }
      })
      this.standardTotal = 0;
      this.practicalTotal = 0;
      // 计算标费
      this.$api.post("/admin/rate/calculationFee", {
        'energyType': energyType,
        'nature': nature, 'carVehicles': carVehicles, 'beginDate': beginDate,
        'tcfee': tcfee, 'sz_tcfee': sz_tcfee, 'sj_tcfee': sj_tcfee,
        'ck_tcfee': ck_tcfee, 'seat': seat
      }).then((res) => {
        if (res.data) {
          this.majorData = this.majorData.map((item) => {
            if (item.type_id == 1 && item.isCheck) {
              // 车损
              item.bztcfee = res.data.z_cs_tcfee;
              // this.standardTotal += res.data.z_cs_tcfee;
              // this.practicalTotal += res.data.z_cs_tcfee * 1;
            }
            if (item.type_id == 2 && item.isCheck) {
              // 三者
              item.bztcfee = res.data.z_sz_tcfee;
              // this.standardTotal += res.data.z_sz_tcfee;
              // this.practicalTotal += res.data.z_sz_tcfee * 1;
            }
            if (item.type_id == 3 && item.isCheck) {
              // 司机
              item.bztcfee = res.data.z_sj_tcfee;
              // this.standardTotal += res.data.z_sj_tcfee;
              // this.practicalTotal += res.data.z_sj_tcfee * 1;
            }
            if (item.type_id == 4 && item.isCheck) {
              // 乘客
              item.bztcfee = res.data.z_ck_tcfee;
              // this.standardTotal += res.data.z_ck_tcfee;
              // this.practicalTotal += res.data.z_ck_tcfee * 1;
            }
            // 计算总价
            if (item.isCheck) {
              this.standardTotal += item.bztcfee * 1;
              this.practicalTotal +=
                item.bztcfee * 1 * this.formData.bill_data.cusRebate;
            }
            return item;
          })
          this.additionData = this.additionData.map((item) => {
            if (item.isCheck) {
              this.standardTotal += item.bztcfee * 1;
              this.practicalTotal +=
                item.bztcfee * 1 * this.formData.bill_data.cusRebate;
            }
            return item;
          });
        }
      });

      //console.log(this.majorData)
    },
    /**
     * 统筹明细相关结束
     */
    /**
     * 特别约定相关开始
     */
    // 选择特别约定
    handleSelectTemp(index) {
      this.personIndex = index;
      this.drawerFlag = "selectTemp";
      this.drawerCfg = {
        title: "选择特别约定",
        visiable: true,
        size: "40%",
      };
      this.handleTableSearch();
    },

    // 选择模版
    handleSelectionChange(selections) {
      // 已选模版
      this.selections = selections;
      // console.log(...arguments);
    },

    // 选择模版确定
    handleSelectTempComfrim() {
      this.selections.forEach((item) => {
        this.formData.bill_data.specialRemark += item.tyContent;
      });
      this.drawerCfg.visiable = false;
    },
    /**
     * 特别约定相关结束
     */
    // 点击弹框/点击保存
    handleDialogComfirm() {
      switch (this.drawerFlag) {
        case "selectCar":
          this.handleCarSubmit();
          break;
        case "selectPerson":
          this.handlePersonSubmit();
          break;
        case "selectTemp":
          this.handleSelectTempComfrim();
          break;

        default:
          break;
      }
    },
    // 图片上传之前
    handlePictureCardPreview(file) {
      //console.log(file);
      this.preImageUrl = file.url;
      this.preVisible = true;
    },
    // 删除图片
    handleRemoveImg(res, fileList, item) {
      this[item.prop] = this[item.prop].filter((el) => el.url !== res.url);
    },

    async handleChangeFile(file, item) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        this[item.prop].push({
          imageType: item.imageType,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },

    uploadSuccess(res, item) {
      if (res.code === 10000) {
        this.$message.success("上传成功");
        //console.log(item);
        // itle: "其他",
        //   imageType: 6,
        //   max: 8,
        //   fileList: this.otherPhoto,
        //   porp: 'otherPhoto'
        //console.log(item.prop, this.identityPhoto);
        this[item.prop].push({
          imageType: item.imageType,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      //console.log(...arguments);
    },
    // 抽屉关闭之后
    drawerClosed() { },

    // 处理统筹明细提交时的数据
    transDetailData(key) {
      return this[key]
        .filter((item) => item.isCheck)
        .map((item) => {
          if (item.isCheck) {
            item.type_id =
              typeof item.type_id === "undefined" ? item.id : item.type_id;
            item.type_pid =
              typeof item.type_pid === "undefined" ? item.pid : item.type_pid;
            return item;
          } else {
            return null;
          }
        });
    },

    validate(flag) {
      return new Promise((resolve, reject) => {
        this.$refs[flag].validate((vali) => {
          if (vali) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    // 点击暂存
    async saveInfoTempor() {
      Object.assign(this.formData.bill_data, {
        standardTotal: this.standardTotal,
        practicalTotal: this.practicalTotal,
        beginTime: this.$moment(this.formData.bill_data.beginTime)
          .utcOffset(8)
          .format("YYYY-MM-DD HH:mm:ss"),
        endTime: this.$moment(this.formData.bill_data.endTime)
          .utcOffset(8)
          .format("YYYY-MM-DD HH:mm:ss"),
      });
      // 归档同凑明细提交数据
      const majorData = this.transDetailData("majorData");
      const additionData = this.transDetailData("additionData");
      this.formData.detail_data = [...majorData, ...additionData];

      // 附件信息处理
      this.formData.enc_data = [
        ...this.identityPhoto,
        ...this.drivingPhoto,
        ...this.businessPhoto,
        ...this.paymentPhoto,
        ...this.validatePhoto,
        ...this.standardPhoto,
        ...this.otherPhoto,
        ...this.dangerNum,
      ];
      let query = await this.$api.post(
        "/admin/insbill/saveall",
        { ...this.formData, insBillId: this.insBillId || 0, whetherxt: this.whetherxt },
        "暂存"
      );
      if (!query) return;
      this.$router.push({
        path: "/issue/offer",
      });
    },

    //保存统筹信息
    async saveInfo() {
      let isValid = false;
      Object.assign(this.formData.bill_data, {
        standardTotal: this.standardTotal,
        practicalTotal: this.practicalTotal,
        beginTime: this.$moment(this.formData.bill_data.beginTime)
          .utcOffset(8)
          .format("YYYY-MM-DD HH:mm:ss"),
        endTime: this.$moment(this.formData.bill_data.endTime)
          .utcOffset(8)
          .format("YYYY-MM-DD HH:mm:ss"),
      });
      isValid = await this.validate("bill_data").catch(() => { });
      if (!isValid) {
        this.$message.warning("请完善基本信息");
        return;
      }
      isValid = await this.validate("car_data").catch(() => { });
      if (!isValid) {
        this.$message.warning("请完善车辆信息");
        return;
      }
      // if (!(this.formData.bill_data.accidentCount >= 0)) {
      //   this.$message.warning("请完善车辆信息-补偿次数信息");
      //   return;
      // }
      // if (!this.paymentPhoto.length) {
      //   this.$message.warning("请完善附件信息-支付凭证信息");
      //   return;
      // }
      let begin = this.$moment(this.formData.bill_data.beginTime).valueOf();
      let now = this.$moment(this.$moment().format("YYYY-MM-DD HH:mm:ss")).valueOf();
      if (begin < now) {
        const res = await this.$confirm("服务起期小于当前时间，是否继续提交？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });;
        if (res !== "confirm") return;
      }
      // 归档同凑明细提交数据
      const majorData = this.transDetailData("majorData");
      const additionData = this.transDetailData("additionData");
      this.formData.detail_data = [...majorData, ...additionData];

      // 附件信息处理
      this.formData.enc_data = [
        ...this.identityPhoto,
        ...this.drivingPhoto,
        ...this.businessPhoto,
        ...this.paymentPhoto,
        ...this.validatePhoto,
        ...this.standardPhoto,
        ...this.otherPhoto,
        ...this.dangerNum,
      ];
      const msg = this.insBillId ? "修改统筹单" : "添加统筹单";
      // insBillId 如果是0是新增、编辑

      if (isValid) {
        let query = this.$api.post(
          "/admin/insbill/saveall",
          { ...this.formData, insBillId: this.insBillId || 0, whetherxt: this.whetherxt },
          msg
        );
        if (!query) return;
        this.$router.push({
          path: "/issue/offer",
        });
      }
    },
    // 重置表单
    async resetInfo() {
      const res = await this.$confirm("重置将会清空您填的数据，是否确认？");
      if (res !== "confirm") return;
      this.formData = {
        //主要信息
        bill_data: {
          cusRebate: 1,
          specialRemark: "",
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
        },
        //人员关系信息
        person_data: [
          {
            personType: 0,
            isgroup: 0,
          },
          {
            personType: 1,
            isgroup: 0,
          },
          {
            personType: 2,
            isgroup: 0,
          },
        ],
        //附件信息
        enc_data: [],
        //统筹详细信息
        detail_data: {},
      };
      this.identityPhoto = [];
      this.drivingPhoto = [];
      this.businessPhoto = [];
      this.validatePhoto = [];
      this.standardPhoto = [];
      this.otherPhoto = [];
      this.dangerNum = [];
      this.getOwnerDetailList();
      this.additionData = [];
    },
    //修改统筹信息
    updataInfo() { },

    // 弹框关闭
    dialogClosed() {
      this.carFormData = {};
      //this.$refs.baseForm.resetFields();
    },

  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;

  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 10px;
    margin-bottom: 20px;

    .header-inner {
      width: 40%;
      display: flex;
      align-items: center;

      .content {
        flex: 1;
      }
    }
  }

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-content: center;

    .panel-header-text {
      .icon {
        color: #666;
        margin-right: 10px;
      }
    }
  }

  .panel-form {
    padding: 20px;
  }

  .base-info {
    padding: 15px;
  }

  .card-info {
    margin-top: 15px;
  }

  .collapse-title {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;

    .title-left {
      display: flex;
      align-items: center;
      color: #666;

      .icon {
        margin-right: 5px;
        margin-top: 3px;
      }
    }

    .title-right {
      margin-right: 10px;
    }
  }

  :deep(.el-card) {
    margin-bottom: 15px;
  }

  :deep(.el-card__header) {
    padding: 10px;
  }

  :deep(.el-card__body) {
    padding: 15px;
  }
}

.select-btn {
  margin-bottom: 15px;
}

.page :deep(.el-form) {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    display: flex;

    .el-form-item__label {
      flex-shrink: 0;
    }

    .el-form-item__content {
      flex: 1;
    }
  }

  .el-input {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 100%;
  }
}

.from-item--30 {
  width: 24%;
}

.has-btn {
  :deep(.el-form-item__content) {
    display: flex;
  }
}

.from-item--100 {
  width: 100%;
}

.confirm {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.enc {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .encTitle {
    &>span {
      margin-left: 15px;
      font-size: 16px;
      color: #666;
    }
  }

  .encNum {
    font-size: 14px;
    color: #666;

    &>span {
      color: red;
      margin-right: 4px;
    }
  }

  .drawer-content {
    width: 100%;
    height: 100%;
  }
}

.input-wrap {
  display: flex;
  align-items: center;

  :deep( .el-input) {
    width: 90px;
    margin-left: 10px;
  }
}

.panel-detail-footer {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;

  .panel-detail-footer-left {
    display: flex;
    align-items: center;

    .label {
      white-space: nowrap;
    }
  }
}

.img-list {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .eg-img {
    // width: 100px;
    // height: 100px;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: flex-start;
  }
}

:deep(.el-icon-circle-close) {
  color: #ef6027;
}
</style>
